module.exports = __webpack_public_path__ + "fonts/Sarabun-Regular.49d082d0.ttf";